// Determine the timezone for a lat/lon (approx) 
import tzlookup from "tz-lookup/tz.js";


import {RegularShape, Circle, Fill, Text, Stroke, Style} from 'ol/style';
import {extend} from 'ol/extent';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import {transform,fromLonLat,toLonLat} from 'ol/proj';
module.exports.ajax= function (url) {
		var async=false;
		//var async=true;
		var ajax;
		var getpost='POST';
		var post='';

		if (window.XMLHttpRequest)  {// code forstandards complient broonFeatureUnselectwsers
			ajax=new XMLHttpRequest();
		}
		else  {// code for Non standards complient browsers
			ajax=new ActiveXObject("Microsoft.XMLHTTP");
		}

		if(async){ //initiate function to run on completion of request
			console.log('Async !!!!!!!!!!!!');
			ajax.onreadystatechange=function()
			{
				if (ajax.readyState===4 && ajax.status===200)
				{
					//    document.getElementById("myDiv").innerHTML=xmlhttp.responseText;
					console.log(ajax.responseText);
					//console.log(box_extents);
				}
			}
		}
		ajax.open(getpost,url,async); //wait for result
		ajax.send(post);
		if(!async){ //wait for request
			console.log('Sync !!!!!!!!!!!!');
			//    document.getElementById("myDiv").innerHTML=xmlhttp.responseText;
			return ajax.responseText;
		}
	};

module.exports.toggleLayer=function(layerName){
	console.log('Layer',layerName);
var found;
map.getLayers().forEach(layer => {
found=false;
	console.log(layer.get('title'));
//Doesn't matter what type if matches
       if(layer.get('title')==layerName){
                  layer.setVisible(!layer.getVisible());
                  found=true;
                  return;
       }
else
   if(layer.getLayers != null) {
       layer.getLayers().forEach(sublayer =>{
       if(sublayer.getLayers == null ) {
	console.log(sublayer.get('title'));
            if(sublayer.get('title')==layerName){
                  sublayer.setVisible(!sublayer.getVisible());
                  found=true;
                  return;
            }
       }
   });
   }
});
return found;
}


//Zoom to fit extent of currently plotted data
module.exports.zoomToFit=function zoomToFit(){

var extent;	
var lyr;
var x=map.getLayerGroup('Geese').getLayersArray().forEach(function(layer,index){
if(layer.getVisible()) // ignore if not visible !!!
//	if(layer.getSource().getState() === 'ready') {
	if(layer.getSource().getFeatures !=null && layer.getSource().getFeatures().length>1){
		if(layer.getSource().getFeatures().length>1){
		if(extent == undefined) 
			extent=layer.getSource().getExtent();
		else if(layer.getSource().getExtent != null)
			extend(extent, layer.getSource().getExtent());
		}
}
});
	if(extent != undefined) // would cause error if zoom no fixes to create extent
		map.getView().fit(extent,map.getSize());
}


module.exports.get_species=function get_species(admin){
	console.log(window.location.href);
	if (
	window.location.href=="http://robin-nuc/goosetracks/admin.html" ||
	window.location.href=="http://goosenews.org/goosetracks/admin.html" ||
	window.location.href=="https://goosenews.org/goosetracks/admin.html" ||
	window.location.href=="http://robin-nuc/goosedevel/admin.html" ||
	window.location.href=="http://goosenews.org/goosedevel/admin.html" ||
	window.location.href=="https://goosenews.org/goosedevel/admin.html" 
	)
		return {"gwhitefront":"Greenland White-fronted Goose","sbarnacle":"Svalbard Barnacle goose","pinkfoot":"Pink-footed goose","bean":"Taiga Bean goose","igreylag":"Greylag goose","unassigned":"Unassigned"};
	return {"gwhitefront":"Greenland White-fronted Goose","sbarnacle":"Svalbard Barnacle goose","igreylag":"Greylag goose"};
	return {"igreylag":"Icelandic Greylag goose","gwhitefront":"Greenland White-fronted Goose","sbarnacle":"Svalbard Barnacle goose","gbarnacle":"Greenland Barnacle goose","unassigned":"Unassigned"};
};



// Shows line feature //
module.exports.animStyle= function animStyle_orig(feature,resolution) {
// Put definitions outside function so don't repeat creation
var color=(feature.get('color'));
var last=(feature.get('last'));
// last feature as star or star
const fill = new Fill({color: color});
var geometry = feature.getGeometry();
if(geometry.getType()=='LineString'){
    var styles = [
        // linestring
        new Style({
            stroke: new Stroke({
                color: color,
                width: 2
            })
        })
    ];

var counter=0;
    geometry.forEachSegment(function (start, end) {
	    if(counter < window.animcount ) {
    var pos=[start[0]+(end[0]-start[0])/2,start[1]+(end[1]-start[1])/2]; //centre of segment
//    console.log('pos:',pos);
//    console.log('start:',start);
//    console.log('end:',end);
    //,start,end);
        var dx = end[0] - start[0];
        var dy = end[1] - start[1];
        var rotation = Math.atan2(dy, dx);

        styles.push(new Style({
          geometry: new Point(pos),
          image: new RegularShape({
            fill: new Fill({color: color}),
	    stroke: new Stroke({
		color: '#FFF',
	}),
            points: 3,
            radius: 6,
            radius2: 2,
            rotation: -rotation,
            angle: Math.PI / 2 // rotate 90°
          })
        }));
		console.log(counter++);
	    }
	});
      return styles;
}
else {
var star= new RegularShape({
      fill: fill,
	stroke: new Stroke({
		color: '#000',
	}),
      points: 5,
      radius: 10,
      radius2: 4,
      angle: 0,
  });

var circle= new Circle({
			radius: 5,
			stroke: new Stroke({
				color: '#fff',
			}),
			fill: fill,
		});

if(last) 
var  image= star;
	else		
var image= circle;

	var style = new Style({
		//Line Style
		stroke: new Stroke({
			color: color,
			width: 2,}),
		// Point Style
		image: image,
		//Text Style
		text: new Text({
			//	text: text.toString(),
			fill: new Fill({
				color: '#fff',
			}),
		}),
      });
      return [style];
    }
}

// Hides line feature //
module.exports.animStyle= function animStyle(feature,resolution) {
// Put definitions outside function so don't repeat creation
var color=(feature.get('color'));
var last=(feature.get('last')); //Flags if last fix
var location_date=(feature.get('location_date'));
var location_date2=(feature.get('next_date'));


/*
 Animation frame may be part way between consecutive moved plots, so needs to show proportionate to time
e.g. fix at x,y at 11:50 then next at 12:22 at X,Y. Animation time frame is 10 mins so animation time is 12:10.
Need to draw extra line 20/32 of the length between 1st plot and next plot.
i.e. proportion  (animation time - current plot time)/(next plot time - current plot time)

new plot to proportion * (newx-oldx) , proportion *(newy-oldy)

Therefore needs to know time and coords of next plot. Use getFeatureById(rownum+1)

*/	


var stopDate = new Date(window.stopAnim);
var locDate = new Date(location_date);
var locDate2 = new Date(location_date2);


if(locDate>=stopDate) {
	return;
}
//else console.log(location_date);



var featId=feature.getId();	

// last feature as star or star
const fill = new Fill({color: color});
var geometry = feature.getGeometry();

if(geometry.getType()=='Point'){
var star= new RegularShape({
      fill: fill,
	stroke: new Stroke({
		color: '#000',
	}),
      points: 5,
      radius: 10,
      radius2: 4,
      angle: 0,
  });

var circle= new Circle({
			radius: 5,
			stroke: new Stroke({
				color: '#000',
			}),
			fill: fill,
		});

if(last) 
var  image= star;
	else		
var image= circle;

	var styles = [
new Style({
		//Line Style
		stroke: new Stroke({
			color: color,
			width: 2,}),
		// Point Style
		image: image,
		//Text Style
		text: new Text({
			//	text: text.toString(),
			fill: new Fill({
				color: '#fff',
			}),
		}),
      })
	];

// Draw line to previous point and add arrow

if(featId>0){
var lyr=feature.getLayer(map);
// Previous point
var oldFeature=lyr.getSource().getFeatureById(featId-1);
var oldGeometry=oldFeature.getGeometry();
var oldPos=oldGeometry.getCoordinates();

// Current point
var pos=geometry.getCoordinates();

// Next point
var nextFeature=lyr.getSource().getFeatureById(featId+1);
if(nextFeature != null){
var prevDate=new Date(nextFeature.get('prev_date'));

// Don't redraw if no movement !!!!!!!
// next feature will have last date/time for this cluster of features as "prev_date"


if(nextFeature.get('prev_date') != null && prevDate>=stopDate){
var nextGeometry=nextFeature.getGeometry();
var nextPos=nextGeometry.getCoordinates();
var proportion=(stopDate-locDate)/(prevDate-locDate2);
var stage=[pos[0]+(nextPos[0]-pos[0])*proportion,pos[1]+(nextPos[1]-pos[1])*proportion]; //centre of segment

	//console.log(locDate,stopDate,prevDate,proportion);
	var lineStr3 = new LineString([
		pos
		,stage
		//,nextPos
	]);

	styles.push(new Style({
          geometry: lineStr3,
	  stroke: new Stroke({
		color: color,
		width: 2,
	  }),
        }));
}
}



// Add line
	var lineStr1 = new LineString([
		pos
		,oldPos
	]);

	styles.push(new Style({
          geometry: lineStr1,
	  stroke: new Stroke({
		color: color,
		width: 2,
	  }),
        }));
// Add arrow
    var middle=[pos[0]+(oldPos[0]-pos[0])/2,pos[1]+(oldPos[1]-pos[1])/2]; //centre of segment
        var dx = pos[0] - oldPos[0];
        var dy = pos[1] - oldPos[1];
        var rotation = Math.atan2(dy, dx);

        styles.push(new Style({
          geometry: new Point(middle),
          image: new RegularShape({
            fill: new Fill({color: color}),
	    stroke: new Stroke({
		color: '#000',
	}),
            points: 3,
            radius: 6,
            radius2: 2,
            rotation: -rotation,
            angle: Math.PI / 2 // rotate 90°
          })
        }));

// Add part of way to next point in current time frame

}



      return styles;
}
else {
    var styles = [
        // linestring
        new Style({
        })
    ];
    }

}




module.exports.tagStyle= function tagStyle(feature,resolution) {
// Put definitions outside function so don't repeat creation
var color=(feature.get('color'));
var last=(feature.get('last'));
// last feature as star or star
const fill = new Fill({color: color});


var geometry = feature.getGeometry();

if(geometry.getType()=='LineString'){
    var styles = [
        // linestring
        new Style({
            stroke: new Stroke({
                color: color,
                width: 2
            })
        })
    ];


    geometry.forEachSegment(function (start, end) {
    var pos=[start[0]+(end[0]-start[0])/2,start[1]+(end[1]-start[1])/2]; //centre of segment
//    console.log('pos:',pos);
//    console.log('start:',start);
//    console.log('end:',end);
    //,start,end);
        var dx = end[0] - start[0];
        var dy = end[1] - start[1];
        var rotation = Math.atan2(dy, dx);

        styles.push(new Style({
          geometry: new Point(pos),
          image: new RegularShape({
            fill: new Fill({color: color}),
	    stroke: new Stroke({
		color: '#000',
	}),
            points: 3,
            radius: 6,
            radius2: 2,
            rotation: -rotation,
            angle: Math.PI / 2 // rotate 90°
          })
        }));
	});
      return styles;
}
else {
var star= new RegularShape({
      fill: fill,
	stroke: new Stroke({
		color: '#000',
	}),
      points: 5,
      radius: 10,
      radius2: 4,
      angle: 0,
  });

var circle= new Circle({
			radius: 5,
			stroke: new Stroke({
				color: '#fff',
			}),
			fill: fill,
		});

if(last) 
var  image= star;
	else		
var image= circle;

	var style = new Style({
		//Line Style
		stroke: new Stroke({
			color: color,
			width: 2,}),
		// Point Style
		image: image,
		//Text Style
		text: new Text({
			//	text: text.toString(),
			fill: new Fill({
				color: '#fff',
			}),
		}),
      });
      return [style];
    }
}




module.exports.getLayerByName=function(layerName){

	var layer2;
//	console.log('Layer',layerName);
//	map.getLayers().forEach(
	map.getLayerGroup('Geese').getLayersArray().forEach( layer => {
//		console.log(layer.get('title'));
       		if(layer.get('title')==layerName){
			layer2=layer; // layer object
		};
	});
	return layer2;
};
var animInterval;
var endDate;
var offset= $("#step_slider").val();

var animlyrs; // available to functions
var vv;
var speed;
var tod;
var this_date;
var prev_date;

module.exports.animate=function(){
endDate=(enddate != '')?new Date(enddate):new Date();
animlyrs= map.getLayerGroup('Geese').getLayersArray().filter(lyr => lyr.getVisible() && !lyr.get('baseLayer') && lyr.get('title')!='Screen');
animlyrs.forEach(function(lyr){
  lyr.setStyle(animStyle); // unless already finished
});

speed= $("#speed_slider").val();
window.stopAnim=new Date(startdate);
animOverlay.show();
animInterval=setInterval( animate2, 60/speed*1000 );
}

function animate2(){

this_date=new Date(window.stopAnim).setHours(0,0,0,0);	

//For all layers
offset= $("#step_slider").val();
//if(typeof window.stopAnim == 'undefined')
//window.stopAnim=new Date(window.stopAnim.setMilliseconds(window.stopAnim.getMilliseconds()+1000*60*offset));
window.stopAnim.setMilliseconds(window.stopAnim.getMilliseconds()+1000*60*offset);
var cntr=toLonLat( map.getView().getCenter() );

// Get the timezone 
//alert(tzlookup(cntr[1],cntr[0])); // prints "America/New_York"

tod=Math.floor(window.stopAnim.getTime()/1000); // Secs since epoch


//Only lookup date_sun_info once per day
if(prev_date == undefined || this_date != prev_date)
$.ajax({ async: false, 	url:'date_sun_info.php',data:{timestamp:tod,latitude:cntr[1],longitude:cntr[0]},success: function(result) {
    vv=JSON.parse(result);
}});
prev_date=this_date;

//console.log(tod,vv.astronomical_twilight_begin);
if(tod<vv.astronomical_twilight_begin){
	//console.log(1);
	getLayerByName('Screen').setOpacity(0.9);
}
else if(tod<vv.sunrise){
	//console.log(2);
	getLayerByName('Screen').setOpacity(0.9-8*(tod - vv.astronomical_twilight_begin)/(vv.sunrise - vv.astronomical_twilight_begin)/10);
}
else if(tod>vv.sunset && tod <vv.astronomical_twilight_end){
	//console.log(3);
	getLayerByName('Screen').setOpacity(0.1+8*(tod - vv.sunset)/(vv.astronomical_twilight_end - vv.sunset)/10);
}
//else console.log(4,tod,vv);

if (window.stopAnim > endDate) {
	clearInterval(animInterval);
	console.log('ended');
	animOverlay.hide();
animlyrs.forEach(function(lyr){
  lyr.setStyle(tagStyle); // unless already finished
});
	getLayerByName('Screen').setOpacity(0);
}




 //$("#animdate").html("<input type='button' id='stop_animation' value='Pause animation'/><input readonly=1 value='"+stopAnim+"'/>");
 $("#animdate").val(stopAnim);
$("#stop_animation").off('click');
$("#stop_animation").on('click',function(e,i){
	switch($(this).val()){
		case 'Pause':
			clearInterval(animInterval);
			$("#stop_animation").val('Resume');
			break;
		case 'Resume':
			$("#stop_animation").val('Pause');
			animInterval=setInterval( animate2, 60/speed*1000 );
			break;
	};

});


animlyrs.forEach(function(lyr){
//lyr.getSource.refresh(); // unless already finished
  lyr.setStyle(animStyle); // unless already finished
});
}
